// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wt33f","col":"styles_col__23AeS","actions":"styles_actions___To-5","conflict":"styles_conflict__324qe"};